import { DefaultTheme } from 'styled-components';

import { LIGHT_COLORS } from './colors';
import { LIGHT_CONFIG } from './config';

const LIGHT_THEME: DefaultTheme = Object.freeze({
  borderRadius: '8px',
  config: LIGHT_CONFIG,
  colors: LIGHT_COLORS,
  scrollBar: LIGHT_COLORS.grey.secondary,
  transition: {
    default: 'all ease-in-out 0.2s',
  },
  responsive: {
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    isTabletUp: false,
  },
});

export { LIGHT_THEME };
